module.exports = __webpack_public_path__ + "img/career-areas/0R2A3200@2x.jpg";